import { Navigate, Outlet, useLocation } from 'react-router-dom';
import { hasAllRoles, hasAnyRoles } from '../../../utils/roles';

import FullLayout from '../../layout/fullLayout/FullLayout';
import React from 'react';
import { useAuthStore } from '../../../store';
import { useIsMutating } from '@tanstack/react-query';

const ProtectedRoute = ({
    roles = ['USER'],
    requireAllRoles = false,
    requireConfirmed = false,
    defaultPath = '/campaigns',
    Layout = FullLayout,
}) => {
    const location = useLocation();
    const authToken = useAuthStore((state) => state.authToken);
    const userProfile = useAuthStore((state) => state.userProfile);

    const isFetching = useIsMutating({ mutationKey: ['user_profile'] });
    if (authToken && isFetching) {
        return <></>;
    }

    const hasAccess = requireAllRoles
        ? hasAllRoles(userProfile, roles)
        : hasAnyRoles(userProfile, roles);

    // authenticated but no access
    if (authToken && userProfile && !hasAccess) {
        return <Navigate to={defaultPath} />;
    }

    // authenticated but requires email confirmation
    if (authToken && requireConfirmed && !userProfile?.emailVerified) {
        return (
            <Navigate
                to={{
                    pathname: '/actions/confirm',
                    state: { from: location.pathname },
                }}
            />
        );
    }
    return authToken && hasAccess ? (
        Layout != null ? (
            <Layout />
        ) : (
            <Outlet />
        )
    ) : (
        <Navigate
            to={{
                pathname: '/auth/login',
                state: { from: location.pathname },
            }}
        />
    );
};
export default ProtectedRoute;
